// @ts-strict-ignore
import {HostBinding, Input, Directive, ChangeDetectorRef} from '@angular/core';

@Directive()
export class LMStyleDirectiveBase {

  @Input() isTag = false;
  @Input() set recalculateStyles(value: boolean) {
    this.setStyles();
  }
  public style: LMFieldStyle;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  @HostBinding('class.lm-font-xl') header1 = false;
  @HostBinding('class.lm-font-lg') header2 = false;
  @HostBinding('class.lm-font-md') header3 = false;
  @HostBinding('class.lm-font-sm') header4 = false;
  @HostBinding('class.lm-font-xs') header5 = false;

  @HostBinding('class.lpl-white') white = false;
  @HostBinding('class.lpl-black') black = false;
  @HostBinding('class.lpl-blue') blue = false;
  @HostBinding('class.lpl-brown') brown = false;
  @HostBinding('class.lpl-gray') gray = false;
  @HostBinding('class.lpl-green') green = false;
  @HostBinding('class.lpl-orange') orange = false;
  @HostBinding('class.lpl-purple') purple = false;
  @HostBinding('class.lpl-red') red = false;
  @HostBinding('class.lpl-turquoise') turquoise = false;
  @HostBinding('class.lpl-yellow') yellow = false;

  // background color bindings for isTag
  @HostBinding('class.lpl-black-bg') bgBlack = false;
  @HostBinding('class.lpl-blue-bg') bgBlue = false;
  @HostBinding('class.lpl-brown-bg') bgBrown = false;
  @HostBinding('class.lpl-gray-bg') bgGray = false;
  @HostBinding('class.lpl-green-bg') bgGreen = false;
  @HostBinding('class.lpl-orange-bg') bgOrange = false;
  @HostBinding('class.lpl-purple-bg') bgPurple = false;
  @HostBinding('class.lpl-red-bg') bgRed = false;
  @HostBinding('class.lpl-turquoise-bg') bgTurquoise = false;
  @HostBinding('class.lpl-yellow-bg') bgYellow = false;

  @HostBinding('class.text-strong') isBold = false;
  @HostBinding('class.text-emphasis') isItalic = false;

  @HostBinding('style.text-align') textAlign = '';
  @HostBinding('class.lm-fixed-font') fixedFont = false;

  public setStyles(): void {
    if (!!this.style) {
      this.resetStyles();
      if (this.style.header) {
        switch(this.style.header) {
          case 1:
            this.header1 = true;
            break;
          case 2:
            this.header2 = true;
            break;
          case 3:
            this.header3 = true;
            break;
          case 4:
            this.header4 = true;
            break;
          case 5:
            this.header5 = true;
            break;
        }
      }

      // Set font color to either black or white on a tag
      if (this.isTag) {
        // this.style.color is bg color
        if (!!this.style.color) {
          switch (this.style.color) {
            case 'black':
            case 'blue':
            case 'brown':
            case 'gray':
            case 'green':
            case 'jade':
            case 'orange':
            case 'purple':
            case 'magenta':
            case 'red':
            case 'maroon':
            case 'turquoise':
              this.white = true;
              break;
            case 'yellow':
              this.black = true;
              break;
          }
        } else {
          // Use black font if color is undefined
          // Need black font on light gray (default) tags for accessibility
          this.black = true;
        }
      }

      // font colors for not isTag
      if (!this.isTag) {
        if (!!this.style.color) {
          switch (this.style.color) {
            case 'black':
              this.black = true;
              break;
            case 'blue':
              this.blue = true;
              break;
            case 'brown':
              this.brown = true;
              break;
            case 'gray':
              this.gray = true;
              break;
            case 'green':
            case 'jade':
              this.green = true;
              break;
            case 'orange':
              this.orange = true;
              break;
            case 'purple':
            case 'magenta':
              this.purple = true;
              break;
            case 'red':
            case 'maroon':
              this.red = true;
              break;
            case 'turquoise':
              this.turquoise = true;
              break;
            case 'yellow':
              this.yellow = true;
              break;
          }
        }
      }

      // background color bindings for isTag
      if (this.isTag) {
        if (!!this.style.color) {
          switch(this.style.color) {
            case 'black':
              this.bgBlack = true;
              break;
            case 'blue':
              this.bgBlue = true;
              break;
            case 'brown':
              this.bgBrown = true;
              break;
            case 'gray':
              this.bgGray = true;
              break;
            case 'green':
            case 'jade':
              this.bgGreen = true;
              break;
            case 'orange':
              this.bgOrange = true;
              break;
            case 'purple':
            case 'magenta':
              this.bgPurple = true;
              break;
            case 'red':
            case 'maroon':
              this.bgRed = true;
              break;
            case 'turquoise':
              this.bgTurquoise = true;
              break;
            case 'yellow':
              this.bgYellow = true;
              // Need black font on yellow tags for accessibility
              this.black = true;
              break;
          }
        }
      }

      if (this?.style?.fixedFont) {
        this.fixedFont = this.style.fixedFont;
      }

      this.isBold = this.style.bold;
      this.isItalic = this.style.italics;
      this.textAlign = this.style.align ? this.style.align : null;

      this.changeDetectorRef.markForCheck();
    }
  }

  private resetStyles(): void {
    this.header1 = false;
    this.header2 = false;
    this.header3 = false;
    this.header4 = false;
    this.header5 = false;

    this.black = false;
    this.blue = false;
    this.brown = false;
    this.gray = false;
    this.green = false;
    this.orange = false;
    this.purple = false;
    this.red = false;
    this.turquoise = false;
    this.yellow = false;

      // background color bindings for isTag
    this.bgBlack = false;
    this.bgBlue = false;
    this.bgBrown = false;
    this.bgGray = false;
    this.bgGreen = false;
    this.bgOrange = false;
    this.bgPurple = false;
    this.bgRed = false;
    this.bgTurquoise = false;
    this.bgYellow = false;

    this.isBold = false;
    this.isItalic = false;

    this.textAlign = '';
  }
}
